// extracted by mini-css-extract-plugin
export default {"input":"hh4aZk"};